// extracted by mini-css-extract-plugin
module.exports = {"formItemGrid":"onboarding-business-details_formItemGrid__W1tkv","phoneInput":"onboarding-business-details_phoneInput__2jXCd"};